(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ws-silly-home"] && !Shopify.designMode) return;
  try {
    
document.dispatchEvent(new Event("ws:silly:render"));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-silly-preview"]) return;
  try {
    
document.dispatchEvent(new Event("ws:silly:render"));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-winter-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ws-winter-edit'))customElements.define('ws-winter-edit',class extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();const signal=this.controller.signal;
    this.track=this.querySelector('.ws-edit__track');
    const preview=window.Shopify?.designMode||['unpublished','development'].includes(window.Shopify?.theme?.role);
    if(preview)this.track.querySelectorAll('template[data-preview-card]').forEach(t=>{t.replaceWith(t.content.cloneNode(true))});
    this.items=[...this.track.querySelectorAll(':scope>.ws-edit__item')];
    this.hidden=this.items.length===0;if(this.hidden)return;
    this.tabs=[...this.querySelectorAll('[role=tab]')];this.buttons=[...this.querySelectorAll('[data-step]')];this.dialog=this.querySelector('dialog');
    this.tabs.forEach(tab=>{
      tab.addEventListener('click',()=>this.selectGroup(tab.dataset.group),{signal});
      tab.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?1:1-this.tabs.indexOf(tab);this.selectGroup(this.tabs[next].dataset.group);this.tabs[next].focus()}},{signal});
    });
    this.buttons.forEach(b=>b.addEventListener('click',()=>this.track.scrollBy({left:Number(b.dataset.step)*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}),{signal}));
    this.track.addEventListener('scroll',()=>this.update(),{signal,passive:true});
    this.track.addEventListener('keydown',e=>{if(e.target===this.track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.track.scrollBy({left:(e.key==='ArrowRight'?1:-1)*this.track.clientWidth/2,behavior:'smooth'})}},{signal});
    this.addEventListener('click',e=>{const trigger=e.target.closest('[data-open-preview]');if(!trigger)return;this.previousFocus=trigger;const content=trigger.closest('.ws-edit__item').querySelector('template[data-preview-content]');this.querySelector('.ws-edit__dialog-body').replaceChildren(content.content.cloneNode(true));this.dialog.showModal();this.dialog.querySelector('.ws-edit__close').focus()},{signal});
    this.querySelector('.ws-edit__close').addEventListener('click',()=>this.dialog.close(),{signal});
    this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},{signal});
    this.dialog.addEventListener('close',()=>this.previousFocus?.focus(),{signal});
    this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.selectGroup('favorite');
  }
  selectGroup(group){
    if(!this.items?.length)return;
    this.items.forEach(item=>item.hidden=item.dataset.group!==group);
    this.tabs.forEach(tab=>{const active=tab.dataset.group===group;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active)this.track.setAttribute('aria-labelledby',tab.id)});
    this.track.scrollLeft=0;
    const personal=this.id==='winter-personal';
    this.querySelector('.ws-edit__shop').href=this.dataset.root+'collections/'+(personal&&group==='new'?'winter-pets':this.dataset.collection);
    this.querySelector('[data-shop-label]').textContent=group==='new'?this.dataset.secondLabel:this.dataset.firstLabel;
    this.update();
  }
  update(){
    const visible=this.items.filter(i=>!i.hidden);const overflow=this.track.scrollWidth>this.track.clientWidth+2;
    this.querySelector('.ws-edit__arrows').hidden=!overflow;
    this.buttons.forEach(b=>b.disabled=Number(b.dataset.step)<0?this.track.scrollLeft<2:this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2);
    const index=visible.length?Math.min(visible.length,Math.round(this.track.scrollLeft/(visible[0].offsetWidth+2))+1):0;
    this.querySelector('.ws-edit__counter').textContent=visible.length?String(index).padStart(2,'0')+' / '+String(visible.length).padStart(2,'0'):'';
  }
  disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();if(this.dialog?.open)this.dialog.close()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-winter-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ws-category-stage')){
  customElements.define('ws-category-stage',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('.ws-stage__track');this.cards=[...this.querySelectorAll('.ws-stage__card')];
      if(!this.cards.length)return;
      this.controller=new AbortController();const signal=this.controller.signal;
      this.buttons=[...this.querySelectorAll('[data-step]')];this.querySelector('.ws-stage__controls').hidden=this.cards.length<2;
      this.buttons.forEach(button=>button.addEventListener('click',()=>this.go(this.index+Number(button.dataset.step)),{signal}));
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update())},{signal,passive:true});
      this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1))}},{signal});
      this.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.ws-stage__card');if(card)this.go(this.cards.indexOf(card))},{signal});
      this.track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      this.track.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0)return;this.dragStart=event.clientX;this.dragScroll=this.track.scrollLeft;this.dragging=false;this.pointer=event.pointerId},{signal});
      this.track.addEventListener('pointermove',event=>{if(this.pointer!==event.pointerId)return;const delta=event.clientX-this.dragStart;if(Math.abs(delta)>8){this.dragging=true;this.track.setPointerCapture(event.pointerId);this.track.style.scrollSnapType='none';this.track.scrollLeft=this.dragScroll-delta}},{signal});
      const finish=()=>{if(this.pointer===undefined)return;this.pointer=undefined;this.track.style.scrollSnapType='';if(this.dragging){this.update();this.go(this.index);this.blockClick=true;setTimeout(()=>this.blockClick=false,0)}};
      this.track.addEventListener('pointerup',finish,{signal});this.track.addEventListener('pointercancel',finish,{signal});
      this.track.addEventListener('click',event=>{if(this.blockClick){event.preventDefault();event.stopPropagation()}},{signal,capture:true});
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);
      requestAnimationFrame(()=>{this.go(Math.min(1,this.cards.length-1),true);this.update()});
    }
    go(index,instant=false){const card=this.cards[Math.max(0,Math.min(index,this.cards.length-1))];const trackRect=this.track.getBoundingClientRect();const rect=card.getBoundingClientRect();this.track.scrollTo({left:this.track.scrollLeft+rect.left-trackRect.left-(this.track.clientWidth-rect.width)/2,behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
    update(){const mid=this.track.getBoundingClientRect().left+this.track.clientWidth/2;let distance=Infinity;this.index=0;this.cards.forEach((card,i)=>{const r=card.getBoundingClientRect();const d=Math.abs(r.left+r.width/2-mid);if(d<distance){distance=d;this.index=i}});this.cards.forEach((card,i)=>card.classList.toggle('is-current',i===this.index));this.buttons.forEach(b=>b.disabled=Number(b.dataset.step)<0?this.index===0:this.index===this.cards.length-1);this.querySelector('.ws-stage__count').textContent=`${String(this.index+1).padStart(2,'0')} / ${String(this.cards.length).padStart(2,'0')}`;const bar=this.querySelector('.ws-stage__progress i');bar.style.width=`${100/this.cards.length}%`;bar.style.transform=`translateX(${this.index*100}%)`}
    disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-winter-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ws-winter-hero'))customElements.define('ws-winter-hero',class extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    document.addEventListener('click',event=>{
      if(!(window.Shopify?.designMode||['unpublished','development'].includes(window.Shopify?.theme?.role)))return;
      const link=event.target.closest('a[href]');if(!link||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const url=new URL(link.href,location.href);if(url.origin!==location.origin)return;
      const targets={'christmas-ugly-sweater':['winter-signature'],'premium-christmas-sweater':['winter-premium'],'christmas-tees':['winter-tees'],'premium-christmas-hoodies':['winter-hoodies'],'winter-family':['winter-personal','favorite'],'winter-pets':['winter-personal','new']};
      const handle=url.pathname.split('/').filter(Boolean).pop();const target=targets[handle];if(!target||!url.pathname.includes('/collections/'))return;
      const section=document.getElementById(target[0]);if(!section)return;
      event.preventDefault();if(target[1])section.selectGroup(target[1]);
      const drawer=document.getElementById('header-sidebar-menu');if(drawer?.open&&typeof drawer.hide==='function')drawer.hide();
      section.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
